import React, { useState } from "react";
import media from "../../../assets/images/media hits/media.png";
import line from "../../../assets/images/media hits/line.png";
import sameerp from "../../../assets/images/media hits/sameerp.jpg";
import PT_26_1 from "../../../assets/images/media hits/PT-26-1.jpg";
import all_media from "../../../assets/images/media hits/all-media.jpg";
import PT_27_1 from "../../../assets/images/media hits/PT-27-1.jpg";
import PT_11 from "../../../assets/images/media hits/PT-11.jpg";
import videoBackground from "../../../assets/video/boston baneer video.mp4";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const initialData = {
  heading:
    "Boston Financial: Holding SMEs' A Strings Right Enough to Let Them Fly",
  profile_header: "Sameer Paddalwar",
  profile_post: "Executive Director CEO",
  img: sameerp,
  first_description:
    "When SMEs seek to break out their current scale and explore means of growing bigger, better and more profitable, there has always been a lack of access to quality financial advisory and consulting experts. To bridge this gap, Boston Financial Advisory Group Inc, a Boston & Bangalore-based company founded in 2010, offers to be a one-stop-shop for all the accounting, financial, consulting and advisory needs. Led by seasoned CFOs with decades of experience in manufacturing, technology, trading and service industries, this company has become the financial outsourcing partner of choice for several companies across various jurisdictions. The company provides advisory for corporate structuring with sheer focus to enhance their balance sheet at any given point of time. Spectrum of Expertise  With the large numbers of startups, early stage and growth stage companies, BFAG has built the expertise in addressing the challenges that exist in this segment like Valuation of enterprise, managing the appropriate cash flows, arranging the funds for sustenance and expansion, appropriate structuring for corporates and information centred F&amp activities that enable business decision making. This support plays an important role in changing the game in favour of such Startups and SMEs. Understanding that the client is squeezed financially, BFAG has priced its services much reasonably. The team of CAs and CS from India and CPAs from U.",
  second_description:
    "S.A. are well versed of the requirements in various jurisdictions, saving a huge time for entrepreneurs and easing their operations irrespective of jurisdiction. BFAG has expertise to establish shared service environment for various multi-country-presence clients with offsite and onsite model. The proper reporting/FP&amp;A in one single currency enables the company to provide solutions to SMEs across the globe. Customised solutions and tools are offered to ease real-time management of information with minimal effort and manual intervention promising high degree of confidentiality on sensitive financial data. The abundant availability of qualified resources hase abled BFAG to be the go-to-vendor for all their F&amp;A needs be it Accounting, Payroll, Compliance, Reporting/MIS/FP&amp;A, Tax filing, Structuring, M&amp;A support, Valuation and Due Diligence. BFAG leverages its more than two decades of experience to understand clients business well and be in a better position to offer customized solutions. Its CPA back-office supports the CPA firms in terms of tax filing in the USA. Reframing the Terms To sustain in the sector that is heavily dominated by practicing CAs/CPAs, invoked the challenge of acquiring the clients and creating proper systems and process.We are flexible enough to work with a startup and competent to meet the requirements of a medium sized company, says BFAG CEO Sameer Paddalwar. BFAG's multi-jurisdictional presence has facilitated it to cater to corporate structuring, financial analytics and control, accounting &amp; reporting and establishing the pitch for funding services for IT/e-Commerce clients. Recently for one of the global giants who incorporated companies in various international jurisdictions, BFAG came up with a consolidated reporting/ FP&amp;A and regulatory calendar to tackle the difference in compliance deadlines and regulatory requirements. In order to keep the client's business intact, the company runs a daily/weekly /monthly/quarterly MIS/FP&amp;A which is more of a business performance review than plain Financial reporting.En route to Future Recording a whopping 100 percent year-on-year growth, BFAG has established its other offices in Pune, Mumbai and Sunnyvale which has employees around 75 experts. Currently the company is concentrating more on small medium sized companies, particularly those who have multi-jurisdiction presence. To achieve a larger client base, BFAG is looking forward to spread its footprint in U.S. and E.U. through alliances and joint ventures.",
};

const initialRelatedNews = [
  {
    posted_on: "27 Apr 2022",
    author: "admin@bfag",
    news_title:
      "Boston Financial: Holding SMEs' F&A Strings Right Enough to Let Them Fly",
    news_link:
      "https://consultants.siliconindia.com/vendor/boston-financial-holding-smes--fa-strings-right-enough-to-let-them-fly-cid-256.html",
    news_img: PT_26_1,
  },
  {
    posted_on: "June 2023",
    author: "admin@bfag",
    news_title: "Listed as top 25th accounting firm in Boston",
    news_link: "https://themanifest.com/accounting/financial/firms/boston",
    news_img: all_media,
  },
  {
    posted_on: "24 March 2020",
    author: "admin@bfag",
    news_title:
      "Tech-driven Accounting & Financial Consulting Services to Help Brands During Crisis",
    news_link:
      "https://www.prnewswire.com/in/news-releases/tech-driven-accounting-amp-financial-consulting-services-to-help-brands-during-crisis-832660697.html",
    news_img: PT_27_1,
  },
  {
    posted_on: "24 March 2020 ",
    author: "admin@bfag",
    news_title:
      "Tech-driven Accounting & Financial Consulting Services to Help Brands During Crisis",
    news_link: "https://www.tmcnet.com/usubmit/2020/03/24/9119676.htm",
    news_img: PT_11,
  },
];

const MediaHits = ({ mediahits }) => {
  const [data, setData] = useState(initialData);
  const [subarray, setSubarray] = useState(null);
  const [isHovered, setIsHovered] = useState(false);

  const selectMediaHit = (object) => {
    setData({
      heading: object.title,
      profile_header: "",
      profile_post: "",
      img: object.imgFile.secure_url,
      first_description: object.shortDesc,
      second_description: "",
    });
    setSubarray(JSON.parse(object.subtitle));
  };

  // Add a fallback to ensure mediahits is an array
  const renderedMediaHits = Array.isArray(mediahits) ? mediahits : [];

  return (
    <>
      <Helmet>
        <title>Boston Financial Advisory Group - Media Hits</title>
        <meta
          name="description"
          content="Discover our media coverage and expert insights. Our passionate team of finance, accounting, law, and compliance professionals deliver impactful financial advisory services."
        />
        <meta
          name="keywords"
          content="Boston Tax financial advisor , Consulting and advisory services , Regulatory compliance ,Financial accounting."
        />
      </Helmet>

      <div className="">
        <div className="">
          {/* <div
          className="banner-wrapper"
          style={{ position: "relative", height: "400px" }}
        >
          <video
            className="banner-video"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
            src={videoBackground}
            autoPlay
            loop
            muted
          />
          <div
            className="banner-overlay"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
          >
            <div className="container-fluid trdBannar h-100">
              <div className="row h-100 d-flex align-items-center">
                <div className="col-lg-6">
                  <div className="banner-content text-white">
                    <h1
                      className="title ml-3"
                      style={{
                        animation: "fadeInLeft 0.5s",
                        animationDelay: "0.5s",
                        fontWeight: "bold",
                        color: "#fff",
                      }}
                    >
                      <a style={{ fontSize: "30px", justifyContent: "center" }}>
                        Media Hits{" "}
                      </a>
                      <br />
                    </h1>
                    <li
                      className="pt-5 "
                      style={{
                        listStyleType: "none",
                        animation: "fadeInLeft 1.3s",
                        animationDelay: "1.3s",
                      }}
                    >
                     
                    </li>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

          <div
            className="d-flex justify-content-center align-items-center banner-image"
            style={{
              background: `url(${media}) no-repeat center`,
              backgroundSize: "cover",
              height: "430px",
            }}
          >
            <div className="d-flex flex-column justify-content-center align-items-center">
              <h3
                className="text-white text-uppercase"
                style={{ fontWeight: "bold" }}
              >
                Media Hits
              </h3>
            </div>
          </div>

          <div className="container-fluid pt-4">
            <div
              className="row d-flex justify-content-start"
              style={{ marginRight: "0px", paddingRight: "0px" }}
            >
              <div
                className="col-lg-9 col-md-12 col-sm-12 col-xs-12"
                id="vendor_chk"
              >
                <div id="borderlinestyle" style={{ marginBottom: "10px" }}>
                  <img
                    alt="Separator"
                    title="Separator"
                    style={{ width: "100%" }}
                    src={line}
                  />
                </div>
                <div className="col-md-12" id="company-title">
                  <h2
                    style={{
                      fontSize: "22px",
                      color: "#002249",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    {data.heading}
                  </h2>
                </div>
                <div id="borderlinestyle" style={{ marginBottom: "10px" }}>
                  <img
                    alt="Separator"
                    title="Separator"
                    style={{ width: "100%" }}
                    src={line}
                  />
                </div>

                <div className="row d-flex justify-content-center align-items-center">
                  <div className="col-lg-4 d-flex justify-content-center align-items-center justify-content-md-center align-items-md-center justify-content-sm-center align-items-sm-center mb-3">
                    <div className="text_style">
                      <div className="text-center ml-3">
                        <img
                          alt="Sameer Paddalwar, Executive Director&amp;CEO"
                          title="Sameer Paddalwar, Executive Director&amp;CEO"
                          src={data.img}
                          // style={{width:'100p%', height:'100%'}}
                        />
                        <div className="profile-text mt-3">
                          <Link
                            to="/sameerpaddalwar"
                            style={{ textDecoration: "none" }}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                          >
                            <h6
                              style={{
                                fontSize: "20px",
                                color: "#072f5f",
                                fontWeight: "bold",
                                position: "relative",
                                display: "inline-block",
                              }}
                            >
                              {data.profile_header}
                              <span
                                style={{
                                  display: "block",
                                  width: isHovered ? "100%" : "0", // Changes width on hover
                                  height: "2px",
                                  backgroundColor: "#072f5f",
                                  position: "absolute",
                                  bottom: "-2px",
                                  left: "0",
                                  transition: "width 0.3s ease",
                                }}
                              />
                            </h6>
                          </Link>
                          <h4
                            style={{
                              textAlign: "center",
                              fontSize: "20px",
                              color: "#072f5f",
                              fontWeight: "bold",
                            }}
                          >
                            {data.profile_post}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 col-sm-12 col-lg-8 d-flex flex-column justify-content-start pl-4">
                    <span
                      style={{
                        color: "#333",
                        textAlign: "justify",
                        fontSize: "9px !important",
                      }}
                    >
                      {data.first_description}
                    </span>
                  </div>
                </div>

                {!subarray ? (
                  <div className=" d-flex  justify-content-start mb-50 pl-2">
                    <span
                      className="justify-text"
                      style={{
                        color: "#333",
                        textAlign: "justify",
                        fontSize: "9px !important",
                      }}
                    >
                      {data.second_description}
                    </span>
                  </div>
                ) : (
                  <div>
                    {subarray.map((subtitle, index) => (
                      <div key={index} className="mt-3">
                        <span
                          className="text-capitalize"
                          style={{
                            fontSize: "1.5rem",
                            fontWeight: "700",
                            color: "#0951A4",
                          }}
                        >
                          {subtitle.title}
                        </span>
                        <p
                          className="text-dark servicep mb-2"
                          style={{ whiteSpace: "pre-line" }}
                        >
                          {subtitle.description}
                        </p>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12">
                <h5
                  className="pb-2"
                  style={{ fontWeight: "bold", textAlign: "center" }}
                >
                  RELATED NEWS
                </h5>
                <div className="d-flex">
                  <div
                    className="justify-content-center"
                    style={{ width: "100%" }}
                  >
                    {initialRelatedNews.map((news, index) => (
                      <a
                        style={{ textDecoration: "none" }}
                        key={index}
                        href={news.news_link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div className="mb-15">
                          <div className="cardsnews">
                            <div
                              className="d-flex flex-row p-2"
                              style={{ gap: "0.10rem" }}
                            >
                              <div className="col-4 col-xl-4 col-sm-4 col-md-3 col-lg-4 pl-0 pr-0">
                                <img
                                  className="img-fluid"
                                  src={news.news_img}
                                  alt="image"
                                  style={{ width: "100%" }}
                                />
                              </div>
                              <div className="col-8 col-xl-8 col-sm-8 col-md-9 col-lg-8 pl-2">
                                <small
                                  style={{ color: "#072F5F", fontSize: "13px" }}
                                >
                                  Posted On {news.posted_on}{" "}
                                  <i className="fas fa-comments-alt"></i> /{" "}
                                  <i className="far fa-user-circle"></i> /{" "}
                                  {news.author}
                                </small>
                                <h3
                                  className="rn-text"
                                  style={{
                                    lineHeight: "normal",
                                    color: "#072F5FA1",
                                    fontSize: "13px",
                                  }}
                                >
                                  {news.news_title}
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    ))}
                    {renderedMediaHits.map((news, index) => (
                      <div key={index} className="mb-15">
                        <div
                          className="cardsnews"
                          onClick={() => selectMediaHit(news)}
                        >
                          <div
                            className="d-flex flex-row p-2"
                            style={{ gap: "0.10rem" }}
                          >
                            <div className="col-4 col-xl-4 col-sm-4 col-md-3 col-lg-4 pl-0 pr-0">
                              <img
                                className="img-fluid"
                                src={news.imgFile.secure_url}
                                alt="image"
                                style={{ width: "100%" }}
                              />
                            </div>
                            <div className="col-8 col-xl-8 col-sm-8 col-md-9 col-lg-8 pl-2">
                              <small style={{ color: "#072F5F" }}>
                                Posted On {news.createdAt}{" "}
                                <i className="fas fa-comments-alt"></i> /{" "}
                                <i className="far fa-user-circle"></i> /{" "}
                                {news.author}
                              </small>
                              <p
                                className="rn-text"
                                style={{
                                  lineHeight: "normal",
                                  color: "#072F5FA1",
                                }}
                              >
                                {news.title}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MediaHits;
